import { Box } from '@mui/material'
import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const FrontEndDetail = () => {
    return (
        <>
            {/* Career Detail Banner */}
            <section className='about-page'>
                <div className='about-bg'>
                    <div className='c-detail-shap-1 con-shap-c'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='about-shap-3'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 con-shap-c'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <div className='career-shap-22'>
                        <img src="../assets/images/whi-3.svg" alt="" />
                    </div>
                    <Container>
                        <Row className='align-items-center'>
                            <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                                <div className='career-img text-center'>
                                    <img src="../assets/images/front-banner.png" alt="" />
                                </div>
                                <div className='career-shap-1'>
                                    <img src="../assets/images/white-arr.svg" alt="" />
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                                <div className='tech-content'>
                                    <h2>Front End Developer</h2>
                                    <p>We’re looking for a Front End Developer who can bring creativity and precision to every interface. At IMUII, you’ll develop responsive, dynamic UIs using frameworks like React or Vue. Collaborate closely with designers and backend teams to deliver seamless user experiences that perform flawlessly across devices. </p>
                                    <div className='interest-btn'>
                                        <Link to='/career-form'>
                                            <button className='job-btn'>I’m Interested</button>
                                        </Link>
                                        <Link to='/career-form'>
                                            <button className='friend-btn'>Refer A Friend</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </div>
            </section>
    
            {/* Information Section */}
            <section className='information-section'>
                <Container>
                    <Row>
                        <div className="col-md-6 mb-30" data-aos="fade-up-right" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Job Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-1.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Region</p>
                                                <h5>Tamil Nadu</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-2.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Industry</p>
                                                <h5>Technology</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                            <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/front-career.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Role</p>
                                                <h5>Front End Developer</h5>
                                            </div>
                                        </Box>
                                        
                                    </div>
                                </Row>
                            </div>
                        </div>
                        <div className="col-md-6 mb-30" data-aos="fade-up-left" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Other Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-4.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Education</p>
                                                <h5>UG / PG</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-5.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Passed Out</p>
                                                <h5>2019</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-6.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Salary Range</p>
                                                <h5>₹ 3 to 7 LPA</h5>
                                            </div>
                                        </Box>
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
    
            {/* Job Description Section */}
            <section className='job-description-section'>
                <Container>
                    <div className='job-description' data-aos="fade-right" data-aos-duration="2000">
                        <h3>Job Description</h3>
                        <p> As a Front End Developer at IMUII, you will create elegant, intuitive user interfaces for our digital platforms. You’ll work closely with designers and backend engineers to ensure seamless, responsive designs across all screen sizes and devices. </p>
                        <p>We’re looking for someone who can translate wireframes into high-quality code using HTML, CSS, JavaScript, and modern frameworks like React or Vue. Attention to performance, usability, and accessibility is essential. </p>
                        <p>You'll also be responsible for troubleshooting, refining UI interactions, and staying up-to-date with evolving trends to maintain a high standard of user experience in every project. </p>
                    </div>
                </Container>
            </section>
    
            {/* Key Responsibility Section */}
            <section className='key-responsibility-section'>
                <Container>
                    <div className='key-responsibility' data-aos="fade-left" data-aos-duration="2000">
                        <h3>Key Responsibility</h3>
                        <ul>
                            <li>
                                <p> Develop responsive web interfaces with clean, maintainable, and scalable code using HTML, CSS, JavaScript. </p>
                            </li>
                            <li>
                                <p>Collaborate with UI/UX designers and backend teams to bring visual concepts to life. </p>
                            </li>
                            <li>
                                <p>Optimize applications for maximum speed and performance across devices and browsers. </p>
                            </li>
                            <li>
                                <p>Ensure cross-browser compatibility and maintain design consistency. </p>
                            </li>
                            <li>
                                <p>Participate in code reviews, daily stand-ups, and sprint planning to support agile development. </p>
                            </li>
                            <li>
                                <p> Identify UI problems and bugs, and devise elegant solutions. </p>
                            </li>
                            <li>
                                <p>Stay current with front-end trends, tools, and best practices. </p>
                            </li>
                            <li>
                                <p>Maintain documentation and follow version control using Git. </p>
                            </li>
                            <li>
                                <p>Advocate for usability, accessibility, and responsive design. </p>
                            </li>
                            <li>
                                <p>Take ownership of assigned features and deliver results within deadlines. </p>
                            </li>
                        </ul>
                    </div>
    
                    <div className='btn-margin' data-aos="zoom-in" data-aos-duration="2000">
                        <Link to='/career-form'>
                            <button className='interested-btn'>I’m Interested</button>
                        </Link>
                    </div>
                </Container>
            </section>
            
        </>
    )
}

export default FrontEndDetail
